import { render, staticRenderFns } from "./pre-buy.vue?vue&type=template&id=67899e74&scoped=true&"
import script from "./pre-buy.vue?vue&type=script&lang=js&"
export * from "./pre-buy.vue?vue&type=script&lang=js&"
import style0 from "./pre-buy.vue?vue&type=style&index=0&id=67899e74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67899e74",
  null
  
)

export default component.exports